import React from 'react';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import { CircleBullet, ColorMarker } from '@/components/atoms';
import { IFilterLink } from './IFilterLinkCmp';

interface IStyledProps {
  active?: boolean;
  bulletLink?: boolean;
  isColor?: boolean;
}

const LinkWrapper = styled.div<IStyledProps>`
  ${props =>
    !props.isColor &&
    css<IStyledProps>`
      min-height: ${props => (props.bulletLink ? '24px' : '40px')};
      padding: ${props => (props.bulletLink ? '0 4px 0 8px' : '4px')};
    `}
  /* border: ${props => (props.bulletLink ? 'none' : '1px solid')}; */
  /* border-color: ${props => props.theme.filterPanel.borderColor}; */
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props =>
    props.active ? props.theme.filterPanel.backgroundColor : 'inherit'};
  font-size: 14px;
`;

const Wrapper = styled.div<IStyledProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 10px;
  margin-bottom: ${props => (props.bulletLink ? '4px' : '0')};
`;

const BulletWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledAnchor = styled.a<IStyledProps>`
  display: block;
  color: ${props => props.theme.paletteDefault.primary.main};
  width: 100%;
  height: 100%;
`;

const FilterLink: React.FC<IFilterLink> = ({
  filterInfo,
  pathInfo,
  noFollow,
  bulletLink,
}) => {
  const { filterKey, filter, active, bgColor, bgImageUrl } = filterInfo;
  const { basePath, slug, queryParams, shallow } = pathInfo;

  let bg_color = bgColor ? [bgColor] : [];
  const isColor = filterKey === 'color';
  let linkContent = isColor ? (
    <ColorMarker
      key={`color-${filter.slug}`}
      bgcolor={bg_color}
      bgimageUrl={bgImageUrl}
      label={filter.label || ''}
      showLabel={true}
      size="small"></ColorMarker>
  ) : (
    filter.label
  );

  if (bulletLink) {
    linkContent = (
      <Wrapper>
        <BulletWrapper>
          <CircleBullet active={active} />
        </BulletWrapper>
        <div>{linkContent}</div>
      </Wrapper>
    );
  }

  let linkItem = (
    <Link
      href={{
        pathname: basePath,
        query: { slug, ...queryParams },
      }}
      passHref
      shallow={shallow}>
      <StyledAnchor
        isColor={isColor}
        active={active}
        bulletLink={bulletLink}
        {...(noFollow ? { rel: 'nofollow' } : {})}
        className={active ? 'smalltitle' : ''}>
        {linkContent}
      </StyledAnchor>
    </Link>
  );

  return (
    <LinkWrapper active={active} bulletLink={bulletLink} isColor={isColor}>
      {linkItem}
    </LinkWrapper>
  );
};

export default FilterLink;
